import { useMutation, useQuery } from '@apollo/client'
import {
  DELETE_PROPERTY_PHOTO,
  GET_SIGNED_FILE_UPLOAD_URLS,
  GET_UPLOADED_DEAL_FILES,
  UPLOAD_TRANSACTION_PHOTOS,
} from './photo-upload'
import type { UploadedDealFiles } from './photo-upload'

export const useGetSignedFileUploadUrls = () => {
  const query = useMutation(GET_SIGNED_FILE_UPLOAD_URLS, {
    fetchPolicy: 'no-cache',
    context: { clientName: typeof window !== 'undefined' ? 'proxy' : null },
  })
  return query
}

export const useUploadTransactionPhotos = () => {
  const query = useMutation(UPLOAD_TRANSACTION_PHOTOS, {
    fetchPolicy: 'no-cache',
    context: { clientName: typeof window !== 'undefined' ? 'proxy' : null },
  })
  return query
}

export const useDeletePropertyPhoto = () => {
  const query = useMutation(DELETE_PROPERTY_PHOTO, {
    fetchPolicy: 'no-cache',
    context: { clientName: typeof window !== 'undefined' ? 'proxy' : null },
  })
  return query
}

export const useGetUploadedDealFiles = (dealId: number): { data: UploadedDealFiles } => {
  const query = useQuery(GET_UPLOADED_DEAL_FILES, {
    variables: { deal_id: dealId },
    fetchPolicy: 'no-cache',
    context: { clientName: typeof window !== 'undefined' ? 'proxy' : null },
  })
  return query
}
